import { LockInfo } from 'src/models/common/LockInfo';
import CONSTANTS from 'src/utils/constants';

/**
 * Derives the VIEW_MODE value from lock state.
 * If lockInfo is null/undefined (backend doesn't return it or hasn't loaded yet),
 * treats as not locked → READ_ONLY (safe default, Edit button will be enabled).
 */
export function deriveViewModeFromLockInfo(
    lockInfo: LockInfo | undefined | null,
    currentUser: string | undefined,
): string {
    if (!lockInfo) {
        return CONSTANTS.VIEW_MODE.READ_ONLY;
    }
    if (currentUser && lockInfo.lockedBy === currentUser) {
        return CONSTANTS.VIEW_MODE.EDITABLE;
    }
    return CONSTANTS.VIEW_MODE.READ_ONLY;
}

export function isLockedByOther(
    lockInfo: LockInfo | undefined | null,
    currentUser: string | undefined,
): boolean {
    if (!lockInfo) {
        return false;
    }
    return lockInfo.lockedBy !== currentUser;
}
